<xemex-dialog-shell [title]="'installationGroups.addLocations.title' | translate">
  <div class="add-locations-dialog__body">
    <xemex-table
      [data]="tableData()"
      [columns]="columns"
      [loading]="isLoading()"
      [totalCount]="totalCount()"
      [selectable]="true"
      [selectionKey]="selectionKey"
      [selectedKeys]="selectedKeys()"
      [rowDisabled]="isMemberRow"
      [disabledRowsChecked]="true"
      (selectedKeysChange)="onSelectedKeysChange($event)"
      (pageChange)="onPageChange($event)"
    >
      <xemex-table-filter-bar
        [filterGroups]="filterGroups()"
        [searchPlaceholder]="'locations.filter.placeholderAll' | translate"
        (searchChange)="onSearchChange($event)"
        (filterChange)="onFilterChange($event)"
      ></xemex-table-filter-bar>
    </xemex-table>
  </div>

  <div actions class="add-locations-dialog__actions">
    <span class="add-locations-dialog__count">
      {{ 'installationGroups.addLocations.selected' | translate: { count: selectedCount() } }}
    </span>
    <div class="add-locations-dialog__action-group">
      <xemex-text-button type="button" intent="primary" (click)="onCancel()">
        {{ 'general.btnCancel' | translate }}
      </xemex-text-button>
      <xemex-filled-button type="button" [disabled]="!selectedCount()" (click)="onAdd()">
        {{ 'installationGroups.addLocations.btnAdd' | translate: { count: selectedCount() } }}
      </xemex-filled-button>
    </div>
  </div>
</xemex-dialog-shell>
